import styled, { css } from 'styled-components';

const hideElement = css`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
`;

export const StyledLabel = styled.label`
  ${hideElement}
`;

export const StyledInput = styled.input`
  ${hideElement}
`;
